import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.RecommendationsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */
export default class RecommendationsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.RecommendationsRestService#getAllAsync
    * @methodOf rest.services.RecommendationsRestService
    * @function
    *
    * @description
    * Retrieves app information.
    *
    * @returns {Promise} The promise of the call.
    */
    getAllAsync() {

        return super.getAllAsync('app-recommendations/');

    }

}

_serviceDependencies.push(RecommendationsRestService);

angular.module('rest.services')
    .service('RecommendationsRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/recommendationsRestService.js